
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';

import { UserAuthContextProvider } from "context/UserContext";

import { RestrictedRoute } from "router/RestrictedRoute";
import { StaffOnlyRoute } from "router/StaffOnlyRoute";
import { CLIENT_ROLE } from "utils/roles";
import { CoursesAreaGate } from "router/CoursesAreaGate";
import { COURSES_OPEN } from "config/courses";
import { ACCESSIBILITY_PATH } from "config/legal";
import SkipLink from "components/A11y/SkipLink";
import RouteAnnouncer from "components/A11y/RouteAnnouncer";

// Admin
import AddLesson from 'pages/admin/AddLesson.js';
import AddPracticeProblem from 'pages/admin/AddPracticeProblem.js';
import ComponentsReferences from 'pages/OriginalIndexPage/ComponentsReferences.js';

// Landing pages
import LandingPage5 from 'pages/examples/LandingPage5.js';
import LandingPage6 from 'pages/examples/LandingPage6.js';
import LandingPage7 from 'pages/examples/LandingPage7.js';
import LandingPage8 from 'pages/examples/LandingPage8.js';
import LandingPage9 from 'pages/examples/LandingPage9.js';
import LandingPage10 from 'pages/examples/LandingPage10.js';
import LandingPage11 from 'pages/examples/LandingPage11.js';

import ContactUs from 'pages/ContactUs/ContactUs.js';
import ContactPage from 'pages/Contact/ContactPage.js';
import Courses from 'pages/courses/Courses.js';
import Courses2 from 'pages/courses/Courses2.js';
import Login from 'pages/examples/Login.js';
import ForgotPasswordComponent from 'pages/examples/ForgotPasswordComponent.js';
import Checkout from 'pages/examples/Checkout.js';
import JavaScriptTableComponent from 'pages/examples/JavaScriptTableComponent.js';
import ClaudeDevTableComponent from 'pages/claudeDevCourse/ClaudeDevTableComponent.js';



import QuizLessonPage from 'pages/examples/QuizLessonPage.js';


import Subscriptions from 'pages/examples/Subscriptions.js';
import Subscriptions2 from 'pages/examples/Subscriptions2.js';
import Subscriptions3 from 'pages/examples/Subscriptions3.js';
import ResourcesPage from 'pages/resources/ResourcesPage.js';
import CheckoutSuccess from 'pages/checkout/CheckoutSuccess.js';
import DesktopAuth from 'pages/desktop/DesktopAuth.js';
import Profile from 'pages/examples/Profile.js';
import Register from 'pages/examples/Register.js';
import RegisterToPlan from 'pages/examples/RegisterToPlan.js';
import GetStarted from 'pages/examples/GetStarted.js';
import AccountSettingsComponent from 'pages/examples/AccountSettings.js';
import AccountDeleted from 'pages/AccountDeleted.js';
import LegalPage from 'pages/legal/LegalPage.js';
import AccessibilityPage from 'pages/legal/AccessibilityPage.js';
import StudioHome from 'pages/studio/StudioHome.js';
import StudioWorkspace from 'pages/studio/StudioWorkspace.js';
import StudioPlans from 'pages/studio/StudioPlans.js';
import LessonTest from 'pages/javascript/lessonTest/lessonTest.js';
import PrimitativeDataTypes from 'pages/java/javaModule3/3-1/3-1-1/PrimitativeDataTypes.js';
import VariableDeclarationAndInitialization from 'pages/java/javaModule3/3-2/3-2-3/VariableDeclarationAndInitialization.js';
import BasicStructureComponent from 'pages/java/module1/BasicStructure/BasicStructureComponent.js';
import SyntaxComponent from 'pages/java/module1/Syntax/SyntaxComponent.js';
import PrintStatementsComponent from 'pages/java/module1/PrintStatements/PrintStatementsComponent.js';
import CommentsComponent from 'pages/java/module1/Comments/CommentsComponent.js';
import IndentationComponent from 'pages/java/module1/Indentation/IndentationComponent.js';
import IndentationInJavaComponent from 'pages/java/module1/IndentationInJava/IndentationInJavaComponent.js';
import AIAssistant from 'pages/AI/AIAssistant.js';
import AiAssistantGate from "components/AiAssistant/AiAssistantGate.js";
import TestVoiceRecorder from "components/TestVoiceRecorder/TestVoiceRecorder.js";

// JavaScript
import JS_M1_L1Component from 'pages/javascript/module1/JS_M1_L1/JS_M1_L1Component.js';
import JS_M1_L2Component from 'pages/javascript/module1/JS_M1_L2/JS_M1_L2Component.js';
import JS_M1_L3Component from 'pages/javascript/module1/JS_M1_L3/JS_M1_L3Component.js';
import JS_M1_L4Component from 'pages/javascript/module1/JS_M1_L4/JS_M1_L4Component.js';
import JS_M1_L5Component from 'pages/javascript/module1/JS_M1_L5/JS_M1_L5Component.js';
import JS_M1_L5_1Component from 'pages/javascript/module1/JS_M1_L5_1/JS_M1_L5_1Component.js';
import JS_M1_L5_2Component from 'pages/javascript/module1/JS_M1_L5_2/JS_M1_L5_2Component.js';
import JS_M1_L5_3Component from 'pages/javascript/module1/JS_M1_L5_3/JS_M1_L5_3Component.js';
import JS_M1_Q1Component from 'pages/javascript/module1/JS_M1_Q1/JS_M1_Q1Component.js';


import JS_M2_L1Component from 'pages/javascript/module2/JS_M2_L1/JS_M2_L1Component.js';
import JS_M2_L2Component from 'pages/javascript/module2/JS_M2_L2/JS_M2_L2Component.js';
import JS_M2_L3Component from 'pages/javascript/module2/JS_M2_L3/JS_M2_L3Component.js';
import JS_M2_L4Component from 'pages/javascript/module2/JS_M2_L4/JS_M2_L4Component.js';
import JS_M2_L5Component from 'pages/javascript/module2/JS_M2_L5/JS_M2_L5Component.js';
import JS_M2_L6Component from 'pages/javascript/module2/JS_M2_L6/JS_M2_L6Component.js';
import JS_M2_L6_1Component from 'pages/javascript/module2/JS_M2_L6/JS_M2_L6Component.js';
import JS_M2_L6_2Component from 'pages/javascript/module2/JS_M2_L6/JS_M2_L6Component.js';
import JS_M2_L7Component from 'pages/javascript/module2/JS_M2_L7/JS_M2_L7Component.js';
import JS_M2_L8Component from 'pages/javascript/module2/JS_M2_L8/JS_M2_L8Component.js';
import JS_M2_L9Component from 'pages/javascript/module2/JS_M2_L9/JS_M2_L9Component.js';
import JS_M2_Q1Component from 'pages/javascript/module2/JS_M2_Q/JS_M2_Q1Component.js';


import JS_M3_L1Component from 'pages/javascript/module3/JS_M3_L1/JS_M3_L1Component.js';
import JS_M3_L2Component from 'pages/javascript/module3/JS_M3_L2/JS_M3_L2Component.js';
import JS_M3_L3Component from 'pages/javascript/module3/JS_M3_L3/JS_M3_L3Component.js';
import JS_M3_L4Component from 'pages/javascript/module3/JS_M3_L4/JS_M3_L4Component.js';
import JS_M3_L5Component from 'pages/javascript/module3/JS_M3_L5/JS_M3_L5Component.js';
import JS_M3_Q1Component from 'pages/javascript/module3/JS_M3_Q/JS_M3_Q1Component.js';


import JS_M4_L1Component from 'pages/javascript/module4/JS_M4_L1/JS_M4_L1Component.js';
import JS_M4_L2Component from 'pages/javascript/module4/JS_M4_L2/JS_M4_L2Component.js';
import JS_M4_L3Component from 'pages/javascript/module4/JS_M4_L3/JS_M4_L3Component.js';
import JS_M4_L4Component from 'pages/javascript/module4/JS_M4_L4/JS_M4_L4Component.js';
import JS_M4_L5Component from 'pages/javascript/module4/JS_M4_L5/JS_M4_L5Component.js';
import JS_M4_L6Component from 'pages/javascript/module4/JS_M4_L6/JS_M4_L6Component.js';
import JS_M4_Q1Component from 'pages/javascript/module4/JS_M4_Q/JS_M4_Q1Component.js';

// Claude Course — "Use Claude Like a Developer" (CC_M1_L1 ... CC_M1_L15)
import CC_M1_L1Component from 'pages/claudeCourse/module1/CC_M1_L1/CC_M1_L1Component.js';
import CC_M1_L2Component from 'pages/claudeCourse/module1/CC_M1_L2/CC_M1_L2Component.js';
import CC_M1_L3Component from 'pages/claudeCourse/module1/CC_M1_L3/CC_M1_L3Component.js';
import CC_M1_L4Component from 'pages/claudeCourse/module1/CC_M1_L4/CC_M1_L4Component.js';
import CC_M1_L5Component from 'pages/claudeCourse/module1/CC_M1_L5/CC_M1_L5Component.js';
import CC_M1_L6Component from 'pages/claudeCourse/module1/CC_M1_L6/CC_M1_L6Component.js';
import CC_M1_L7Component from 'pages/claudeCourse/module1/CC_M1_L7/CC_M1_L7Component.js';
import CC_M1_L8Component from 'pages/claudeCourse/module1/CC_M1_L8/CC_M1_L8Component.js';
import CC_M1_L9Component from 'pages/claudeCourse/module1/CC_M1_L9/CC_M1_L9Component.js';
import CC_M1_L10Component from 'pages/claudeCourse/module1/CC_M1_L10/CC_M1_L10Component.js';
import CC_M1_L11Component from 'pages/claudeCourse/module1/CC_M1_L11/CC_M1_L11Component.js';
import CC_M1_L12Component from 'pages/claudeCourse/module1/CC_M1_L12/CC_M1_L12Component.js';
import CC_M1_L13Component from 'pages/claudeCourse/module1/CC_M1_L13/CC_M1_L13Component.js';
import CC_M1_L14Component from 'pages/claudeCourse/module1/CC_M1_L14/CC_M1_L14Component.js';
import CC_M1_L15Component from 'pages/claudeCourse/module1/CC_M1_L15/CC_M1_L15Component.js';

// Claude AI Developer — "Claude AI Developer" (CD_M1_L1 ... CD_M5_L5)
import CD_M1_L1Component from 'pages/claudeDevCourse/module1/CD_M1_L1/CD_M1_L1Component.js';
import CD_M1_L2Component from 'pages/claudeDevCourse/module1/CD_M1_L2/CD_M1_L2Component.js';
import CD_M1_L3Component from 'pages/claudeDevCourse/module1/CD_M1_L3/CD_M1_L3Component.js';
import CD_M1_L4Component from 'pages/claudeDevCourse/module1/CD_M1_L4/CD_M1_L4Component.js';
import CD_M1_L5Component from 'pages/claudeDevCourse/module1/CD_M1_L5/CD_M1_L5Component.js';
import CD_M1_L6Component from 'pages/claudeDevCourse/module1/CD_M1_L6/CD_M1_L6Component.js';
import CD_M2_L1Component from 'pages/claudeDevCourse/module2/CD_M2_L1/CD_M2_L1Component.js';
import CD_M2_L2Component from 'pages/claudeDevCourse/module2/CD_M2_L2/CD_M2_L2Component.js';
import CD_M2_L3Component from 'pages/claudeDevCourse/module2/CD_M2_L3/CD_M2_L3Component.js';
import CD_M2_L4Component from 'pages/claudeDevCourse/module2/CD_M2_L4/CD_M2_L4Component.js';
import CD_M2_L5Component from 'pages/claudeDevCourse/module2/CD_M2_L5/CD_M2_L5Component.js';
import CD_M2_L6Component from 'pages/claudeDevCourse/module2/CD_M2_L6/CD_M2_L6Component.js';
import CD_M2_L7Component from 'pages/claudeDevCourse/module2/CD_M2_L7/CD_M2_L7Component.js';
import CD_M3_L1Component from 'pages/claudeDevCourse/module3/CD_M3_L1/CD_M3_L1Component.js';
import CD_M3_L2Component from 'pages/claudeDevCourse/module3/CD_M3_L2/CD_M3_L2Component.js';
import CD_M3_L3Component from 'pages/claudeDevCourse/module3/CD_M3_L3/CD_M3_L3Component.js';
import CD_M3_L4Component from 'pages/claudeDevCourse/module3/CD_M3_L4/CD_M3_L4Component.js';
import CD_M3_L5Component from 'pages/claudeDevCourse/module3/CD_M3_L5/CD_M3_L5Component.js';
import CD_M3_L6Component from 'pages/claudeDevCourse/module3/CD_M3_L6/CD_M3_L6Component.js';
import CD_M4_L1Component from 'pages/claudeDevCourse/module4/CD_M4_L1/CD_M4_L1Component.js';
import CD_M4_L2Component from 'pages/claudeDevCourse/module4/CD_M4_L2/CD_M4_L2Component.js';
import CD_M4_L3Component from 'pages/claudeDevCourse/module4/CD_M4_L3/CD_M4_L3Component.js';
import CD_M4_L4Component from 'pages/claudeDevCourse/module4/CD_M4_L4/CD_M4_L4Component.js';
import CD_M4_L5Component from 'pages/claudeDevCourse/module4/CD_M4_L5/CD_M4_L5Component.js';
import CD_M4_L6Component from 'pages/claudeDevCourse/module4/CD_M4_L6/CD_M4_L6Component.js';
import CD_M5_L1Component from 'pages/claudeDevCourse/module5/CD_M5_L1/CD_M5_L1Component.js';
import CD_M5_L2Component from 'pages/claudeDevCourse/module5/CD_M5_L2/CD_M5_L2Component.js';
import CD_M5_L3Component from 'pages/claudeDevCourse/module5/CD_M5_L3/CD_M5_L3Component.js';
import CD_M5_L4Component from 'pages/claudeDevCourse/module5/CD_M5_L4/CD_M5_L4Component.js';
import CD_M5_L5Component from 'pages/claudeDevCourse/module5/CD_M5_L5/CD_M5_L5Component.js';

// Claude AI Developer V2 (CD02) — tester-only while it's being evaluated.
// A SEPARATE course from CD01 above, not a replacement (V2_M1_L1 ... V2_M5_L5).
import ClaudeDevV2TableComponent from 'pages/claudeDevV2Course/ClaudeDevV2TableComponent.js';
import V2_M1_L1Component from 'pages/claudeDevV2Course/module1/V2_M1_L1/V2_M1_L1Component.js';
import V2_M1_L2Component from 'pages/claudeDevV2Course/module1/V2_M1_L2/V2_M1_L2Component.js';
import V2_M1_L3Component from 'pages/claudeDevV2Course/module1/V2_M1_L3/V2_M1_L3Component.js';
import V2_M1_L4Component from 'pages/claudeDevV2Course/module1/V2_M1_L4/V2_M1_L4Component.js';
import V2_M1_L5Component from 'pages/claudeDevV2Course/module1/V2_M1_L5/V2_M1_L5Component.js';
import V2_M1_L6Component from 'pages/claudeDevV2Course/module1/V2_M1_L6/V2_M1_L6Component.js';
import V2_M1_L7Component from 'pages/claudeDevV2Course/module1/V2_M1_L7/V2_M1_L7Component.js';
import V2_M1_L8Component from 'pages/claudeDevV2Course/module1/V2_M1_L8/V2_M1_L8Component.js';
import V2_M2_L1Component from 'pages/claudeDevV2Course/module2/V2_M2_L1/V2_M2_L1Component.js';
import V2_M2_L2Component from 'pages/claudeDevV2Course/module2/V2_M2_L2/V2_M2_L2Component.js';
import V2_M2_L3Component from 'pages/claudeDevV2Course/module2/V2_M2_L3/V2_M2_L3Component.js';
import V2_M2_L4Component from 'pages/claudeDevV2Course/module2/V2_M2_L4/V2_M2_L4Component.js';
import V2_M2_L5Component from 'pages/claudeDevV2Course/module2/V2_M2_L5/V2_M2_L5Component.js';
import V2_M2_L6Component from 'pages/claudeDevV2Course/module2/V2_M2_L6/V2_M2_L6Component.js';
import V2_M2_L7Component from 'pages/claudeDevV2Course/module2/V2_M2_L7/V2_M2_L7Component.js';
import V2_M3_L1Component from 'pages/claudeDevV2Course/module3/V2_M3_L1/V2_M3_L1Component.js';
import V2_M3_L2Component from 'pages/claudeDevV2Course/module3/V2_M3_L2/V2_M3_L2Component.js';
import V2_M3_L3Component from 'pages/claudeDevV2Course/module3/V2_M3_L3/V2_M3_L3Component.js';
import V2_M3_L4Component from 'pages/claudeDevV2Course/module3/V2_M3_L4/V2_M3_L4Component.js';
import V2_M3_L5Component from 'pages/claudeDevV2Course/module3/V2_M3_L5/V2_M3_L5Component.js';
import V2_M3_L6Component from 'pages/claudeDevV2Course/module3/V2_M3_L6/V2_M3_L6Component.js';
import V2_M3_L7Component from 'pages/claudeDevV2Course/module3/V2_M3_L7/V2_M3_L7Component.js';
import V2_M3_L8Component from 'pages/claudeDevV2Course/module3/V2_M3_L8/V2_M3_L8Component.js';
import V2_M3_L9Component from 'pages/claudeDevV2Course/module3/V2_M3_L9/V2_M3_L9Component.js';
import V2_M4_L1Component from 'pages/claudeDevV2Course/module4/V2_M4_L1/V2_M4_L1Component.js';
import V2_M4_L2Component from 'pages/claudeDevV2Course/module4/V2_M4_L2/V2_M4_L2Component.js';
import V2_M4_L3Component from 'pages/claudeDevV2Course/module4/V2_M4_L3/V2_M4_L3Component.js';
import V2_M4_L4Component from 'pages/claudeDevV2Course/module4/V2_M4_L4/V2_M4_L4Component.js';
import V2_M4_L5Component from 'pages/claudeDevV2Course/module4/V2_M4_L5/V2_M4_L5Component.js';
import V2_M4_L6Component from 'pages/claudeDevV2Course/module4/V2_M4_L6/V2_M4_L6Component.js';
import V2_M4_L7Component from 'pages/claudeDevV2Course/module4/V2_M4_L7/V2_M4_L7Component.js';
import V2_M4_L8Component from 'pages/claudeDevV2Course/module4/V2_M4_L8/V2_M4_L8Component.js';
// V2_M5_L2/L3/L4/L6 used to be here. Those four lessons were retired when Module 5
// became the shipping module; their replacements (V2_M5_L11–L10) are registry-routed
// below, so only these two keep a hand-written component file.
import V2_M5_L1Component from 'pages/claudeDevV2Course/module5/V2_M5_L1/V2_M5_L1Component.js';
import V2_M5_L5Component from 'pages/claudeDevV2Course/module5/V2_M5_L5/V2_M5_L5Component.js';

// CD02 lessons added after the original 38 shipped — Module 6 (Claude Code) and
// Module 5's V2_M5_L11–L10 — are routed from the registry through one shared page
// instead of a per-lesson component file each. The originals are deliberately left
// exactly as they are; `isRegistryRoutedV2`, defined below the imports, is the
// boundary between the two styles.
import V2LessonPage from 'pages/claudeDevV2Course/V2LessonPage.js';
import { CLAUDE_DEV_V2_COURSE_LESSONS } from 'pages/claudeDevV2Course/devV2LessonsRegistry.js';

// Claude AI Developer V3 (CD03) — a SEPARATE course from CD01 and CD02 above,
// neither of which is touched (V3_M1_L1 ... V3_M5_L6).
//
// Unlike those two, CD03 does not get one component and one hand-written <Route>
// per lesson: every lesson renders through V3LessonPage, and its routes are mapped
// from the registry below. That is 3 imports instead of 37 and no third copy of the
// route list to keep in sync.
import ClaudeDevV3TableComponent from 'pages/claudeDevV3Course/ClaudeDevV3TableComponent.js';
import V3LessonPage from 'pages/claudeDevV3Course/V3LessonPage.js';
import { CLAUDE_DEV_V3_COURSE_LESSONS } from 'pages/claudeDevV3Course/devV3LessonsRegistry.js';

// Claude AI Developer V4 (CD04) — the final cut, assembled from lessons chosen out
// of CD01, CD02 and CD03, none of which is touched (V4_M1_L1 ... V4_M5_L6).
// Registry-routed like CD03: one page component, one mapped route list.
import ClaudeDevV4TableComponent from 'pages/claudeDevV4Course/ClaudeDevV4TableComponent.js';
import V4LessonPage from 'pages/claudeDevV4Course/V4LessonPage.js';
import { CLAUDE_DEV_V4_COURSE_LESSONS } from 'pages/claudeDevV4Course/devV4LessonsRegistry.js';


// Which CD02 lessons are routed from the registry rather than a hand-written
// component file: all of Module 6, plus Module 5's four shipping lessons. Used for
// both the <Route> elements and the lesson-route list, so the two cannot disagree.
const REGISTRY_ROUTED_V2 = ["V2_M5_L11", "V2_M5_L12", "V2_M5_L13", "V2_M5_L14"];
const isRegistryRoutedV2 = (l) =>
	l.route.startsWith("V2_M6_") || REGISTRY_ROUTED_V2.includes(l.route);


const App = () => {
	const [currentPageContext, setCurrentPageContext] = useState(null);
	const [currentLesson, setCurrentLesson] = useState(null);
	const [currentProblems, setCurrentProblems] = useState(null);
	const [currentCode, setCurrentCode] = useState(null);
	const [currentOuput, setCurrentOuput] = useState(null);
	const aiOpenHelpRef = useRef(null);


	const location = useLocation();

	const isGetStarted = location.pathname === "/get-started";
	const isLanding5 = location.pathname === "/landing-page5";
	const isClaudeCourse = location.pathname.startsWith("/CC_M");
	const isClaudeDevCourse = location.pathname.startsWith("/CD_M");
	const isClaudeDevV2Course = location.pathname.startsWith("/V2_M");
	const isClaudeDevV3Course = location.pathname.startsWith("/V3_M");
	const isClaudeDevV4Course = location.pathname.startsWith("/V4_M");


	const lessonRoutes = [

		"/JS_M1_L1",
		"/JS_M1_L2",
		"/JS_M1_L3",
		"/JS_M1_L4",
		"/JS_M1_L5",
		"/JS_M1_L5_1",
		"/JS_M1_L5_2",
		"/JS_M1_L5_3",

		"/JS_M2_L1",
		"/JS_M2_L2",
		"/JS_M2_L3",
		"/JS_M2_L4",
		"/JS_M2_L5",
		"/JS_M2_L6",
		"/JS_M2_L6_1",
		"/JS_M2_L6_2",
		"/JS_M2_L7",
		"/JS_M2_L8",
		"/JS_M2_L9",

		"/JS_M3_L1",
		"/JS_M3_L2",
		"/JS_M3_L3",
		"/JS_M3_L4",
		"/JS_M3_L5",

		"/JS_M4_L1",
		"/JS_M4_L2",
		"/JS_M4_L3",
		"/JS_M4_L4",
		"/JS_M4_L5",
		"/JS_M4_L6",

		"/CC_M1_L1",
		"/CC_M1_L2",
		"/CC_M1_L3",
		"/CC_M1_L4",
		"/CC_M1_L5",
		"/CC_M1_L6",
		"/CC_M1_L7",
		"/CC_M1_L8",
		"/CC_M1_L9",
		"/CC_M1_L10",
		"/CC_M1_L11",
		"/CC_M1_L12",
		"/CC_M1_L13",
		"/CC_M1_L14",
		"/CC_M1_L15",

		"/CD_M1_L1",
		"/CD_M1_L2",
		"/CD_M1_L3",
		"/CD_M1_L4",
		"/CD_M1_L5",
		"/CD_M1_L6",

		"/CD_M2_L1",
		"/CD_M2_L2",
		"/CD_M2_L3",
		"/CD_M2_L4",
		"/CD_M2_L5",
		"/CD_M2_L6",
		"/CD_M2_L7",

		"/CD_M3_L1",
		"/CD_M3_L2",
		"/CD_M3_L3",
		"/CD_M3_L4",
		"/CD_M3_L5",
		"/CD_M3_L6",

		"/CD_M4_L1",
		"/CD_M4_L2",
		"/CD_M4_L3",
		"/CD_M4_L4",
		"/CD_M4_L5",
		"/CD_M4_L6",

		"/CD_M5_L1",
		"/CD_M5_L2",
		"/CD_M5_L3",
		"/CD_M5_L4",
		"/CD_M5_L5",

		"/V2_M1_L1",
		"/V2_M1_L2",
		"/V2_M1_L3",
		"/V2_M1_L4",
		"/V2_M1_L5",
		"/V2_M1_L6",
		"/V2_M1_L7",
		"/V2_M1_L8",

		"/V2_M2_L1",
		"/V2_M2_L2",
		"/V2_M2_L3",
		"/V2_M2_L4",
		"/V2_M2_L5",
		"/V2_M2_L6",
		"/V2_M2_L7",

		"/V2_M3_L1",
		"/V2_M3_L2",
		"/V2_M3_L3",
		"/V2_M3_L4",
		"/V2_M3_L5",
		"/V2_M3_L6",
		"/V2_M3_L7",
		"/V2_M3_L8",
		"/V2_M3_L9",

		"/V2_M4_L1",
		"/V2_M4_L2",
		"/V2_M4_L3",
		"/V2_M4_L4",
		"/V2_M4_L5",
		"/V2_M4_L6",
		"/V2_M4_L7",
		"/V2_M4_L8",

		"/V2_M5_L1",
		"/V2_M5_L5",

		// CD02's registry-routed lessons — Module 6 and Module 5's V2_M5_L11–L10 —
		// derived from the registry, like CD03 below, so they can't drift out of this
		// list. The hand-written ones stay hand listed alongside the route elements
		// they belong to.
		...CLAUDE_DEV_V2_COURSE_LESSONS
			.filter(isRegistryRoutedV2)
			.map((l) => `/${l.route}`),

		// CD03 — derived from the registry rather than listed by hand, so this
		// can't drift out of sync with the course the way a fourth copy would.
		...CLAUDE_DEV_V3_COURSE_LESSONS.map((l) => `/${l.route}`),

		// CD04 — same deal.
		...CLAUDE_DEV_V4_COURSE_LESSONS.map((l) => `/${l.route}`),
	];

	useEffect(() => {
		// console.log("EFFECT IN APP IS WORKING!!!!")
	}, [currentLesson]);


	useEffect(() => {
		const isLessonPage = lessonRoutes.includes(location.pathname);

		if (!isLessonPage) {
			setCurrentPageContext("basic");
			setCurrentLesson(null);
			setCurrentProblems(null);
			setCurrentCode(null);
		}
	}, [location.pathname]);

	return (
		<>
			{/* First tab stop on every page, before any navbar. */}
			<SkipLink />
			{/* Page title in the browser tab, and a screen-reader note on route changes. */}
			<RouteAnnouncer />
			<UserAuthContextProvider>
				{/* While COURSES_OPEN is false every course URL below — the hub, the
				    tables of contents, the free first lessons and the gated ones —
				    redirects to /subscriptions for everyone except admins and testers.
				    Wrapping <Routes> rather than re-indenting 110 route lines; see
				    router/CoursesAreaGate.js. */}
				<CoursesAreaGate>
				<Routes>
					{/* LandingPage11 is the live homepage as of 2026-09-01. It also
					    keeps its own /landing-page11 URL below, so the earlier
					    drafts can still be opened side by side. To roll back, point
					    this one route at another LandingPageN — nothing else in the
					    app refers to the homepage by component. */}
					<Route path='/' exact element={<LandingPage11 />} />

					{/* Reference and test pages: admin and tester accounts only.
					    Everyone else is sent to the homepage. These pages show
					    plans, prices, guarantees and legal links that are not what
					    Codenec sells today, so a visitor must not read them as real
					    offers. The code stays so the designs can be reused. See
					    router/StaffOnlyRoute.js. */}
					<Route element={<StaffOnlyRoute />}>
					<Route path='/components' exact element={<ComponentsReferences />} />

					{/* Page bellow is for testing */}
					<Route path='/test-recorder' exact element={<TestVoiceRecorder />} />


					{/* Landing Routing  */}
					<Route path='/landing-page5' exact element={<LandingPage5 />} />
					<Route path='/landing-page6' exact element={<LandingPage6 />} />
					<Route path='/landing-page7' exact element={<LandingPage7 />} />
					{/* LandingPage8 is the offer-plan revision of 7 — leads with the
					    day-one win, adds the proof and bonus sections, prices on the
					    monthly plan, and reads its own lp8.* copy in both locales.
					    LandingPage7 still serves '/' so the two can be compared side
					    by side; to promote 8, point '/' at it above. */}
					<Route path='/landing-page8' exact element={<LandingPage8 />} />
					{/* LandingPage9 is a straight copy of LandingPage7, kept as the
					    working base for the next landing revision. Its CSS is the same
					    sheet under an lp9 prefix, so it can diverge from 7 freely. */}
					<Route path='/landing-page9' exact element={<LandingPage9 />} />
					{/* LandingPage10 is NOT a revision of 6-9. Those all run the
					    same sales flow and sell the course; 10 leads with the
					    mission and sells the outcome — an online system you own —
					    with no price card and both CTAs pointing at
					    /subscriptions. Own lp10.* copy in both locales, own
					    stylesheet. Kept as the runner-up to LandingPage11, which
					    now serves '/'. */}
					<Route path='/landing-page10' exact element={<LandingPage10 />} />

					{/* Older pricing, course and checkout pages, and test pages. */}
					<Route path='/subscriptions2' element={<Subscriptions2 />} />
					<Route path='/subscriptions3' element={<Subscriptions />} />
					<Route path='/courses2' element={<Courses2 />} />
					<Route path='/checkout' element={<Checkout />} />
					<Route path='/quiz' exact element={<QuizLessonPage />} />
					<Route path='/lesson' element={<LessonTest />} />
					<Route path='/PrimitativeDataTypes' element={<PrimitativeDataTypes />} />
					<Route path='/VariableDeclarationAndInitialization' element={<VariableDeclarationAndInitialization />} />

					{/* Admin tools (the backend also requires the admin role). */}
					<Route path='/add-lesson' element={<AddLesson />} />
					<Route path='/add-pp' element={<AddPracticeProblem />} />
					</Route>

					{/* LandingPage11 WON the 10-vs-11 comparison and is what '/'
					    serves; this URL is kept so it can still be opened next to
					    the older drafts. Built from the "Build Your Own Online
					    System With AI" PDF: it sells the product (a ready-made
					    application foundation you point AI at) and carries that
					    PDF's own wording of the mission, where 10 sells the
					    outcome. Its CTAs go to /contact, not /subscriptions. */}
					<Route path='/landing-page11' exact element={<LandingPage11 />} />


					<Route path='/login-page' exact element={<Login />} />
					<Route path='/forgot-password' exact element={<ForgotPasswordComponent />} />
					<Route path='/profile-page' exact element={<Profile />} />
					<Route path='/register-page' exact element={<Register />} />
					<Route path='/register-to-plan' exact element={<RegisterToPlan />} />
					<Route path='/contactus' element={<ContactUs />} />
					{/* /contact is LandingPage11's CTA target — a form on LP11's own
					    dark hero, and MainFooter's "Contact" link. /contactus above is
					    the support page, linked as "Support" from MainFooter and from
					    landings 1-5; the two are deliberately separate. */}
					<Route path='/contact' element={<ContactPage />} />
					<Route path='/courses' element={<Courses />} />
					<Route path='/get-started' element={<GetStarted />} />
					<Route path='/subscriptions' element={<Subscriptions3 />} />
					{/* Post-Stripe interstitial: polls for webhook entitlement, then routes on. Must stay OUTSIDE RestrictedRoute. */}
					<Route path='/checkout/success' element={<CheckoutSuccess />} />
					{/* Codenec Desktop sign-in. Must stay OUTSIDE RestrictedRoute and must never redirect: the query string is the whole flow, so the page signs people in inline instead. */}
					<Route path='/desktop-auth' element={<DesktopAuth />} />
					{/* Confirmation after a self-serve account deletion (Account settings → Security). Must stay OUTSIDE RestrictedRoute: the account and its sign-in are already gone when it renders. */}
					<Route path='/account-deleted' element={<AccountDeleted />} />
					{/* Terms, Privacy and Refund policies (drafts until the lawyer approves; see config/legal.js). Public: must stay OUTSIDE RestrictedRoute. */}
					<Route path='/terms' element={<LegalPage doc="terms" />} />
					<Route path='/privacy' element={<LegalPage doc="privacy" />} />
					<Route path='/refunds' element={<LegalPage doc="refunds" />} />
					{/* Accessibility statement, linked from MainFooter. Public, like the policies above. */}
					<Route path={ACCESSIBILITY_PATH} element={<AccessibilityPage />} />
					<Route path='/javascript-table' element={<JavaScriptTableComponent />} />
					<Route path='/claudedev-table' element={<ClaudeDevTableComponent />} />
					{/* Claude AI Developer V2 — table of contents is public, open to all users */}
					<Route path='/claudedev-v2-table' element={<ClaudeDevV2TableComponent />} />
					{/* Claude AI Developer V3 — table of contents is public, open to all users */}
					<Route path='/claudedev-v3-table' element={<ClaudeDevV3TableComponent />} />
					{/* Claude AI Developer V4 — table of contents is public, open to all users */}
					<Route path='/claudedev-v4-table' element={<ClaudeDevV4TableComponent />} />

					{/* Same assistant as a full page. Its navbar link was already
					    admin-only, but the URL was open to anyone who typed it —
					    RestrictedRoute lets admins/testers through and bounces the
					    rest, matching AiAssistantGate on the floating orb. */}
					<Route element={<RestrictedRoute requiredRole="admin" />}>
						<Route path='/ai' element={<AIAssistant />} />
					</Route>

					{/* Client resources. requiredRole takes a list here; admins and
					    testers are let through by RestrictedRoute's own privileged
					    check, so they do not need to be named. Guarding the ROUTE as
					    well as the menu item matters — the nav link is hidden for a
					    course student, but the URL would otherwise still open. */}
					<Route element={<RestrictedRoute requiredRole={[CLIENT_ROLE]} />}>
						<Route path='/resources' element={<ResourcesPage />} />
					</Route>

					{/* Account settings needs a signed-in account and nothing more -
					    no role, no payment. It used to be an open route, so a
					    signed-out visitor got the page with no user behind it and an
					    uncaught TypeError on user.uid from its subscription fetch.
					    RestrictedRoute sends them to sign in instead. */}
					<Route element={<RestrictedRoute />}>
						<Route path='/accountsettings' element={<AccountSettingsComponent />} />
					</Route>

					{/* The public Studio plans page. Must stay OUTSIDE RestrictedRoute:
					    visitors read the offer before they have an account. A static
					    path, so it wins over /studio/:projectId below. */}
					<Route path='/studio/plans' element={<StudioPlans />} />

					{/* Codenec Studio: invited clients build web apps with AI. The
					    route only needs a signed-in account; the real gate is
					    users/{uid}.studioEnabled, which the Studio service checks
					    on every call (no role bypass), and the pages explain the
					    invite when it is missing. */}
					<Route element={<RestrictedRoute />}>
						<Route path='/studio' element={<StudioHome />} />
						<Route path='/studio/:projectId' element={<StudioWorkspace />} />
					</Route>

					<Route path='/basicStructure' element={<BasicStructureComponent content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} />} />
					<Route path='/syntax' element={<SyntaxComponent />} />
					<Route path='/printStatements' element={<PrintStatementsComponent />} />
					<Route path='/comments' element={<CommentsComponent />} />
					<Route path='/indentation' element={<IndentationComponent />} />
					<Route path='/indentationInJava' element={<IndentationInJavaComponent />} />

					{/* Claude Course — "Use Claude Like a Developer" */}
					<Route path='/CC_M1_L1' element={<CC_M1_L1Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

					{/* Claude AI Developer — first lesson is public */}
					<Route path='/CD_M1_L1' element={<CD_M1_L1Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

					{/* Claude AI Developer V2 — first lesson is public; remaining lessons gated below */}
					<Route path='/V2_M1_L1' element={<V2_M1_L1Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

					{/* Claude AI Developer V3 — first lesson is public; remaining lessons gated below */}
					<Route path={`/${CLAUDE_DEV_V3_COURSE_LESSONS[0].route}`} element={<V3LessonPage route={CLAUDE_DEV_V3_COURSE_LESSONS[0].route} setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

					{/* Claude AI Developer V4 — first lesson is public; remaining lessons gated below */}
					<Route path={`/${CLAUDE_DEV_V4_COURSE_LESSONS[0].route}`} element={<V4LessonPage route={CLAUDE_DEV_V4_COURSE_LESSONS[0].route} setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

					{/* JavaScript */}
					<Route path='/JS_M1_L1' element={<JS_M1_L1Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />

					{/* Non-testers who reach a tester-only route land here. */}
					<Route path='/unauthorized' element={<Navigate to={COURSES_OPEN ? "/courses" : "/subscriptions"} replace />} />

					{/* Claude AI Developer V2 (CD02) — open to all users, gated like CD01: the
					    table of contents and first lesson (V2_M1_L1) are public above, and every
					    remaining lesson requires an active subscription or the one-time course
					    purchase — the same gate CD01's L2+ use. */}
					<Route element={<RestrictedRoute requirePayment={true} />}>
						<Route path='/V2_M1_L2' element={<V2_M1_L2Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M1_L3' element={<V2_M1_L3Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M1_L4' element={<V2_M1_L4Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M1_L5' element={<V2_M1_L5Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M1_L6' element={<V2_M1_L6Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M1_L7' element={<V2_M1_L7Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M1_L8' element={<V2_M1_L8Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

						<Route path='/V2_M2_L1' element={<V2_M2_L1Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M2_L2' element={<V2_M2_L2Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M2_L3' element={<V2_M2_L3Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M2_L4' element={<V2_M2_L4Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M2_L5' element={<V2_M2_L5Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M2_L6' element={<V2_M2_L6Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M2_L7' element={<V2_M2_L7Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

						<Route path='/V2_M3_L1' element={<V2_M3_L1Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M3_L2' element={<V2_M3_L2Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M3_L3' element={<V2_M3_L3Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M3_L4' element={<V2_M3_L4Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M3_L5' element={<V2_M3_L5Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M3_L6' element={<V2_M3_L6Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M3_L7' element={<V2_M3_L7Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M3_L8' element={<V2_M3_L8Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M3_L9' element={<V2_M3_L9Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

						<Route path='/V2_M4_L1' element={<V2_M4_L1Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M4_L2' element={<V2_M4_L2Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M4_L3' element={<V2_M4_L3Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M4_L4' element={<V2_M4_L4Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M4_L5' element={<V2_M4_L5Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M4_L6' element={<V2_M4_L6Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M4_L7' element={<V2_M4_L7Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M4_L8' element={<V2_M4_L8Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

						<Route path='/V2_M5_L1' element={<V2_M5_L1Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/V2_M5_L5' element={<V2_M5_L5Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
					</Route>

					{/* CD02's registry-routed lessons — Module 6 (Claude Code) and Module 5's
					    shipping lessons V2_M5_L11–L10 — paywalled exactly like V2_M1_L2 onward
					    above; only V2_M1_L1 and the table of contents are free. Mapped from
					    the registry through one V2LessonPage rather than a per-lesson
					    component file each, the way CD03 does below. Kept as its own block so
					    the hand-written routes above stay untouched and the boundary between
					    the two styles is visible. */}
					<Route element={<RestrictedRoute requirePayment={true} />}>
						{CLAUDE_DEV_V2_COURSE_LESSONS
							.filter(isRegistryRoutedV2)
							.map((l) => (
								<Route key={l.route} path={`/${l.route}`} element={<V2LessonPage route={l.route} setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
							))}
					</Route>

					{/* Claude AI Developer V3 (CD03) — open to all users, gated exactly like
					    CD01/CD02: the table of contents and first lesson are public above, and
					    `.slice(1)` puts every remaining lesson behind an active subscription or
					    the one-time course purchase. Mapping the registry rather than listing
					    35 routes by hand means a lesson added to CD03 is routed automatically,
					    and the free/paid boundary stays a single visible line. */}
					<Route element={<RestrictedRoute requirePayment={true} />}>
						{CLAUDE_DEV_V3_COURSE_LESSONS.slice(1).map((l) => (
							<Route key={l.route} path={`/${l.route}`} element={<V3LessonPage route={l.route} setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						))}
					</Route>

					{/* Claude AI Developer V4 (CD04) — gated exactly like CD03 above: the
					    table of contents and first lesson are public, and `.slice(1)` puts
					    every remaining lesson behind an active subscription or the one-time
					    course purchase. */}
					<Route element={<RestrictedRoute requirePayment={true} />}>
						{CLAUDE_DEV_V4_COURSE_LESSONS.slice(1).map((l) => (
							<Route key={l.route} path={`/${l.route}`} element={<V4LessonPage route={l.route} setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						))}
					</Route>

					<Route element={<RestrictedRoute requirePayment={true} />}>
						<Route path='/JS_M1_L2' element={<JS_M1_L2Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M1_L3' element={<JS_M1_L3Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M1_L4' element={<JS_M1_L4Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M1_L5' element={<JS_M1_L5Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M1_L5_1' element={<JS_M1_L5_1Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M1_L5_2' element={<JS_M1_L5_2Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M1_L5_3' element={<JS_M1_L5_3Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M1_Q1' element={<JS_M1_Q1Component />} />

						<Route path='/JS_M2_L1' element={<JS_M2_L1Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M2_L2' element={<JS_M2_L2Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M2_L3' element={<JS_M2_L3Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M2_L4' element={<JS_M2_L4Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M2_L5' element={<JS_M2_L5Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M2_L6' element={<JS_M2_L6Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M2_L6_1' element={<JS_M2_L6Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M2_L6_2' element={<JS_M2_L6Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M2_L7' element={<JS_M2_L7Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M2_L8' element={<JS_M2_L8Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M2_L9' element={<JS_M2_L9Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M2_Q1' element={<JS_M2_Q1Component />} />

						<Route path='/JS_M3_L1' element={<JS_M3_L1Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M3_L2' element={<JS_M3_L2Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M3_L3' element={<JS_M3_L3Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M3_L4' element={<JS_M3_L4Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M3_L5' element={<JS_M3_L5Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M3_Q1' element={<JS_M3_Q1Component />} />

						<Route path='/JS_M4_L1' element={<JS_M4_L1Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M4_L2' element={<JS_M4_L2Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M4_L3' element={<JS_M4_L3Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M4_L4' element={<JS_M4_L4Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M4_L5' element={<JS_M4_L5Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M4_L6' element={<JS_M4_L6Component setAiPageContext={setCurrentPageContext} content={currentLesson} onLoadLesson={setCurrentLesson} practiceProblems={currentProblems} onPracticeProblems={setCurrentProblems} setCurrentCode={setCurrentCode} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/JS_M4_Q1' element={<JS_M4_Q1Component />} />

						{/* Claude Course — lessons 2-15 (payment-gated) */}
						<Route path='/CC_M1_L2' element={<CC_M1_L2Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L3' element={<CC_M1_L3Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L4' element={<CC_M1_L4Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L5' element={<CC_M1_L5Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L6' element={<CC_M1_L6Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L7' element={<CC_M1_L7Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L8' element={<CC_M1_L8Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L9' element={<CC_M1_L9Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L10' element={<CC_M1_L10Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L11' element={<CC_M1_L11Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L12' element={<CC_M1_L12Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L13' element={<CC_M1_L13Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L14' element={<CC_M1_L14Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CC_M1_L15' element={<CC_M1_L15Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

						{/* Claude AI Developer — lessons 2-30 (payment-gated) */}
						<Route path='/CD_M1_L2' element={<CD_M1_L2Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M1_L3' element={<CD_M1_L3Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M1_L4' element={<CD_M1_L4Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M1_L5' element={<CD_M1_L5Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M1_L6' element={<CD_M1_L6Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

						<Route path='/CD_M2_L1' element={<CD_M2_L1Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M2_L2' element={<CD_M2_L2Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M2_L3' element={<CD_M2_L3Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M2_L4' element={<CD_M2_L4Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M2_L5' element={<CD_M2_L5Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M2_L6' element={<CD_M2_L6Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M2_L7' element={<CD_M2_L7Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

						<Route path='/CD_M3_L1' element={<CD_M3_L1Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M3_L2' element={<CD_M3_L2Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M3_L3' element={<CD_M3_L3Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M3_L4' element={<CD_M3_L4Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M3_L5' element={<CD_M3_L5Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M3_L6' element={<CD_M3_L6Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

						<Route path='/CD_M4_L1' element={<CD_M4_L1Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M4_L2' element={<CD_M4_L2Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M4_L3' element={<CD_M4_L3Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M4_L4' element={<CD_M4_L4Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M4_L5' element={<CD_M4_L5Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M4_L6' element={<CD_M4_L6Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

						<Route path='/CD_M5_L1' element={<CD_M5_L1Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M5_L2' element={<CD_M5_L2Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M5_L3' element={<CD_M5_L3Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M5_L4' element={<CD_M5_L4Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />
						<Route path='/CD_M5_L5' element={<CD_M5_L5Component setAiPageContext={setCurrentPageContext} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />} />

					</Route>


					<Route path='*' element={<Navigate to='/' replace />} />
				</Routes>
				</CoursesAreaGate>
				{/* The gate renders nothing unless the signed-in user is an admin or
				    tester — the path checks below only decide which pages the orb is
				    allowed on. The #ai-robot-dock guards in DemoNavbar and
				    LessonNavBar must agree, or an empty socket is left behind. */}
				{!isGetStarted && !isLanding5 && !isClaudeCourse && !isClaudeDevCourse && !isClaudeDevV2Course && !isClaudeDevV3Course && !isClaudeDevV4Course && <AiAssistantGate AiPageContex={currentPageContext} setAiPageContext={setCurrentPageContext} currentLesson={currentLesson} onUpdateLesson={setCurrentLesson} currentProblems={currentProblems} onUpdateProblems={setCurrentProblems} currentCode={currentCode} openHelpRef={aiOpenHelpRef} currentOuput={currentOuput} setCurrentOuput={setCurrentOuput} />}
			</UserAuthContextProvider>
		</>
	);
};


export default App;